// extracted by mini-css-extract-plugin
module.exports = {"actions":"Groups_actions__5-l29"};